import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./../../Shared/Home.css";
import { baseUrl } from "./../../Apiurls/Apiurls";
import { useContext } from "react";
import { AuthContext } from "./../../Contextapi/ContextApi";
import Navbar from "../../Shared/Navbar";

const ViewAnalysis = () => {
  const { logout } = useContext(AuthContext);
  const { id } = useParams(); // Get the email parameter from the URL
  const [userData, setUserData] = useState(null);
  const [isEditing, setIsEditing] = useState(false); // State to track editing mode
  const [editedData, setEditedData] = useState({});
  const navigate = useNavigate();




    const fetchData = async () => {
      try {
        const response = await fetch(`${baseUrl}/api/tracker/${id}`);
        if (!response.ok) {
          if (response.status === 404) {
            console.log("No matching records found");
          } else {
            throw new Error("Failed to fetch data from server");
          }
          return;
        }

        const data = await response.json();
        setUserData(data);
        setEditedData(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

useEffect(() => {
    fetchData(); // ✅ Can now call directly
  }, [id]);

  const handleBackClick = () => {
    navigate("/view"); // Navigate back to the View component
  };

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleNavigation = (path) => {
    navigate(path);
  };

  


  const handleUpdateClick = async () => {
  try {
    const response = await fetch(`${baseUrl}/api/fulltracker/${id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(editedData), // send all fields except `id`
    });

    if (!response.ok) {
      const errData = await response.json();
      alert("Error updating analysis: " + (errData.error || response.statusText));
      return;
    }

    alert("Data updated successfully");
    setIsEditing(false);
    fetchData();
  } catch (error) {
    console.error("Error updating data:", error);
    alert("Error updating analysis. Please check server.");
  }
};

  const calculateExpectedCTC = (ctcType, currentFixedCTC, currentTotalCTC, ctcIncreasePercentage) => {
    let calculatedCTC = 0;
    if (ctcType === "Current Fixed CTC") {
      calculatedCTC = currentFixedCTC + (ctcIncreasePercentage * currentFixedCTC) / 100;
    } else if (ctcType === "Current Total CTC") {
      calculatedCTC = currentTotalCTC + (ctcIncreasePercentage * currentTotalCTC) / 100;
    }
    return calculatedCTC;
  };

  const handleInputChange = (e, key) => {
    const newValue = e.target.value;
    const updatedData = { ...editedData, [key]: newValue };

    // Calculate the expected CTC if the relevant fields are updated
    if (["ctcType", "currentFixedCTC", "currentTotalCTC", "ctcIncreasePercentage"].includes(key)) {
      const { ctcType, currentFixedCTC, currentTotalCTC, ctcIncreasePercentage } = updatedData;
      updatedData.calculatedCTC = calculateExpectedCTC(ctcType, parseFloat(currentFixedCTC), parseFloat(currentTotalCTC), parseFloat(ctcIncreasePercentage));
    }

    setEditedData(updatedData);
  };
  // Define an array of fields to display with labels and values
  const fieldsToDisplay = [
    { label: "Name", key: "name" },
    { label: "Organisation", key: "organisation" },
    { label: "Designation", key: "designation" },
    { label: "Total Experience", key: "totalExperience" },
    { label: "FMCG Sales Experience", key: "fmcgSalesExp" },
    { label: "Education Qualification", key: "educationQualification" },
    { label: "Pedigree", key: "pedigree" },
    { label: "Gender", key: "gender" },
    { label: "Age", key: "age" },
    { label: "Location", key: "location" },
    { label: "Contact No.", key: "contactNo" },
    { label: "Email", key: "email" },
    { label: "Payroll", key: "payroll" },
    { label: "Trade Handled", key: "tradeHandled" },
    { label: "Business Volume", key: "businessVolume" },
    { label: "Geography Covered", key: "geographyCovered" },
    { label: "Candidate’s Native Place", key: "nativePlace" },
    { label: "Distributors Handled", key: "distributorsHandled" },
    { label: "Products Handled", key: "productsHandled" },
    { label: "Accounts Retail Counters", key: "accountsRetailCounters" },
    { label: "Team Size", key: "teamSize" },
    { label: "Reporting To", key: "reportingTo" },
    { label: "Monthly Turnover", key: "monthlyTurnover" },
    { label: "Current Total CTC", key: "currentTotalCTC" },
    { label: "Current Fixed CTC", key: "currentFixedCTC" },
    { label: "Current Variable CTC", key: "currentVariableCTC" },
    { label: "CTC Increase Percentage", key: "ctcIncreasePercentage" },
    { label: "CTC Increase In Percentage Based On", key: "ctcType" },
    { label: "Expected CTC", key: "calculatedCTC" },
    { label: "Is CTC Negotiable", key: "isCTCNegotiable" },
    { label: "Reason For Change", key: "reasonForChange" },
    { label: "Is Notice Period Negotiable", key: "isNoticePeriodNegotiable" },
    { label: "Notice Period", key: "noticePeriod" },
    { label: "Positions Suitable For", key: "positionsSuitableFor" },
    { label: "Skills", key: "skills" },
    { label: "Languages Known", key: "languagesKnown" },
    { label: "IT Languages Known", key: "itLanguagesKnown" },
    { label: "Databases Known", key: "databasesKnown" },
    { label: "Software Known", key: "softwareKnown" },
    { label: "Additional Skills", key: "additionalSkills" },
    { label: "LinkedIn Profile", key: "linkedinProfile" },
    { label: "Comments", key: "comments" },
    { label: "Shortlist", key: "shortlist" },
    { label: "Source", key: "source" },
    { label: "Shared On", key: "sharedOn" },
    { label: "Consultant", key: "consultant" },
    { label: "Assessment", key: "assessment" },
  ];

  const dropdownOptions = {

    
  
    
    gender: [
      { value: "", label: "Select" },
      { value: "Male", label: "Male" },
      { value: "Female", label: "Female" },
    ],
    
    educationQualification: [
      { value: "", label: "Select Qualification" },
      { value: "10th", label: "10th" },
      { value: "Intermediate", label: "Intermediate" },
      { value: "Diploma", label: "Diploma" },
      { value: "Btech", label: "Btech" },
      { value: "B.E", label: "B.E" },
      { value: "BA ", label: "BA" },
      { value: "B.com", label: "B.com" },
      { value: "PGDM", label: "PGDM" },
      { value: "MBA", label: "MBA" },
      { value: "Postgraduate", label: "Postgraduate" },
      { value: "Bsc ", label: "Bsc" },
      { value: "other ", label: "other" },
    ],
    payroll: [
      { value: "", label: "Select" },
      { value: "Onroll", label: "Onroll" },
      { value: "Offroll", label: "Offroll" },
    ],
    isCTCNegotiable: [
      { value: "", label: "Select" },
      { value: "Yes", label: "Yes" },
      { value: "No", label: "No" },
    ],
    ctcType: [
      { value: "", label: "Select" },
      { value: "Current Total CTC", label: "Current Total CTC" },
      { value: "Current Fixed CTC", label: "Current Fixed CTC" },
    ],
    noticePeriod: [
      { value: "", label: "Select" },
      { value: "Immediate", label: "Immediate" },
      { value: "15 days", label: "15 days" },
      { value: "30 days", label: "30 days" },
      { value: "45 days", label: "45 days" },
      { value: "2 months", label: "2 months" },
      { value: "3 months", label: "3 months" },
    ],
    source: [
      { value: "", label: "Select" },
      { value: "Refer", label: "Refer" },
      { value: "Linkedin", label: "Linkedin" },
      { value: "Social Media", label: "Social Media" },
      { value: "Others", label: "Others" },
    ],
  };

  const handleLogout = () => {
    logout();
    // Display an alert for logout success
    alert("You have successfully logged out");

    // Redirect to the root or landing page (adjust the path as needed)
    navigate("/");
  };

  return (
    <div className="container-fluid mt-5 mb-5">
      <div className="row">
        <div className="col-md-2">
          <Navbar/>
        </div>

        <div className="col-md-10">
          <h2 className="text-center mb-4" style={{marginTop: "50px"}}>View Analysis</h2>
          {userData && (
            <div className="card">
              <div className="row">
                {fieldsToDisplay.map((field) => (
                  <div className="col-md-4" key={field.key}>
                    <div className="card-body">
                      <label>{field.label}:</label>
                      {isEditing ? (
                        dropdownOptions[field.key] ? (
                          <select
                            value={editedData[field.key]}
                            onChange={(e) => handleInputChange(e, field.key)}
                            className="form-control"
                          >
                            {dropdownOptions[field.key].map((option) => (
                              <option key={option.value} value={option.value}>
                                {option.label}
                              </option>
                            ))}
                          </select>
                        ) : (
                          <input
                            type="text"
                            value={editedData[field.key]}
                            onChange={(e) => handleInputChange(e, field.key)}
                            className="form-control"
                          />
                        )
                      ) : (
                        <input
                          type="text"
                          value={userData[field.key]}
                          readOnly
                          className="form-control"
                        />
                      )}
                    </div>
                  </div>
                ))}
              </div>
              <div className="d-flex justify-content-center mt-3 mb-5">
                {isEditing ? (
                  <button
                    className="btn btn-primary"
                    onClick={handleUpdateClick}
                  >
                    Update
                  </button>
                ) : (
                  <button className="btn btn-primary" onClick={handleEditClick}>
                    Edit
                  </button>
                )}
                <div style={{ marginLeft: "20px" }}>
                  <button
                    className="btn btn-secondary"
                    onClick={handleBackClick}
                  >
                    Back
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ViewAnalysis;
